// NPM import
import React, { Component } from 'react';

// Project imports

import Icon from '../../../../components/Icon';

// Component

import './styles.css';

class Panel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCollapsed: props.initialCollapseState || false,
    };
  }

  _toggleCollapse = () => {
    this.setState(
      {
        isCollapsed: !this.state.isCollapsed,
      },
      () => {
        const { onExpand, onCollapse } = this.props;
        if (this.state.isCollapsed && onCollapse) onCollapse();
        if (!this.state.isCollapsed && onExpand) onExpand();
      },
    );
  };

  render() {
    const {
      title,
      isHeaderShort,
      children,
      collapsible,
      rightIcon,
      className,
      label,
    } = this.props;

    const { isCollapsed } = this.state;

    return (
      <div className={`Panel ${className || ''}`}>
        <div
          className={`Panel__header ${isHeaderShort ? 'Panel__header-short' : ''} ${isCollapsed && 'Panel__header-collapsed'}`}
          onClick={() => { if (collapsible) this._toggleCollapse(); }}
        >
          <span className="Panel__header-title">{title}</span>
          {
            rightIcon &&
            rightIcon()
          }
          {
            collapsible &&
            <Icon
              className="Panel__collapse-indicator"
              name={isCollapsed ? 'expand_more' : 'expand_less'}
            />
          }
          {
            label &&
            !collapsible &&
            <span className="Panel__desc-label">{label}</span>
          }

        </div>
        {
          !isCollapsed &&
          <div className="Panel__content">
            {children}
          </div>
        }
      </div>
    );
  }
}

export default Panel;
